import './HighlightBlock.css'

function HighlightBlock ({ text }) {
	return (
		<div className="highlight-block">
			{text}
		</div>
	);
};

export default HighlightBlock;
